import React, { useEffect, useState } from "react"
import * as SelectPrimitive from "@radix-ui/react-select"
import { Icon } from "@iconify/react"
import { cn } from "../../lib/utils"

const Select = ({ options, value, onValueChange, placeholder, className }) => {
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    if (!isOpen) return undefined

    const body = document.body
    const originalStyles = {
      overflowY: body.style.overflowY,
      marginRight: body.style.marginRight,
      paddingRight: body.style.paddingRight,
    }

    body.style.setProperty("overflow-y", "scroll", "important")
    body.style.setProperty("margin-right", "0px", "important")
    body.style.setProperty("padding-right", "0px", "important")

    return () => {
      body.style.overflowY = originalStyles.overflowY
      body.style.marginRight = originalStyles.marginRight
      body.style.paddingRight = originalStyles.paddingRight
    }
  }, [isOpen])

  return (
  <SelectPrimitive.Root
    value={value}
    onValueChange={onValueChange}
    open={isOpen}
    onOpenChange={setIsOpen}
    modal={false}
  >
    <SelectPrimitive.Trigger
      aria-label={placeholder}
      className={cn(
        "flex w-full items-center justify-between rounded-md border border-gray-200 bg-white px-3 py-3 text-left text-sm text-gray-400 outline-none transition-colors",
        "hover:border-gray-300 focus:border-[#1b667a]",
        className
      )}
    >
      <SelectPrimitive.Value placeholder={placeholder} />
      <SelectPrimitive.Icon>
        <Icon icon="mdi:chevron-down" className="h-4 w-4 text-gray-400" />
      </SelectPrimitive.Icon>
    </SelectPrimitive.Trigger>

    <SelectPrimitive.Portal>
      <SelectPrimitive.Content
        position="popper"
        sideOffset={4}
        className="z-50 max-h-60 w-[var(--radix-select-trigger-width)] overflow-y-auto rounded-md border border-gray-200 bg-white py-1 text-sm shadow-md"
      >
        <SelectPrimitive.Viewport>
          {options.map((option) => (
            <SelectPrimitive.Item
              key={option.value}
              value={option.value}
              className="relative flex w-full cursor-default select-none items-center px-3 py-2 text-gray-600 outline-none hover:bg-[#1b667a]/10 hover:text-[#1b667a] focus:bg-[#1b667a]/10 focus:text-[#1b667a] data-[state=checked]:font-medium data-[state=checked]:text-[#1b667a]"
            >
              <SelectPrimitive.ItemText>{option.label}</SelectPrimitive.ItemText>
            </SelectPrimitive.Item>
          ))}
        </SelectPrimitive.Viewport>
      </SelectPrimitive.Content>
    </SelectPrimitive.Portal>
  </SelectPrimitive.Root>
  )
}

export { Select }
